import React from 'react';
import { Text } from '@ayble-health/dashboard-components';
import { Loader } from '../../Loader';
import type {
  BlockStableStrings,
  DashboardBlock,
  UserBlock,
} from '../../../models/block';
import type { AnyNutritionBlockData } from '../../../models/nutritionBlockData';
import { BlockCreateContent } from './BlockCreateContent';
import { BlockEditContent } from './BlockEditContent';
import { NutritionBlockDetailsContent } from './NutritionBlockDetailsContent';
import { BlockDrawerMode } from './types';

type Props = {
  activeAssignedBlockNames: Set<string>;
  drawerError?: string;
  editableBlock: UserBlock | null;
  isDrawerLoading: boolean;
  mode: BlockDrawerMode;
  nutritionBlockDetails: {
    data: AnyNutritionBlockData | null;
    nutritionBlockType: BlockStableStrings | null;
  };
  blockOptions: DashboardBlock[];
  onBackToBlockList: () => void;
  onCreateBlock: (block: DashboardBlock) => void;
  onPatientInstructionsChange: (text: string) => void;
  onSelectBlock: (block: DashboardBlock) => void;
  patientInstructions: string;
  selectedBlock: DashboardBlock | null;
  handleUpdateUserBlock: () => void;
};

export const BlockDrawerContent = (props: Props) => {
  if (props.isDrawerLoading) return <Loader loading />;

  if (props.drawerError) {
    return <Text color={'error.600'}>{props.drawerError}</Text>;
  }

  if (props.mode === BlockDrawerMode.Details) {
    return (
      <NutritionBlockDetailsContent
        nutritionBlockType={props.nutritionBlockDetails.nutritionBlockType}
        nutritionBlockData={props.nutritionBlockDetails.data}
      />
    );
  }

  if (props.mode === BlockDrawerMode.Edit && props.editableBlock) {
    return (
      <BlockEditContent
        block={props.editableBlock}
        instructions={props.patientInstructions}
        onInstructionsChange={props.onPatientInstructionsChange}
        handleUpdateUserBlock={props.handleUpdateUserBlock}
      />
    );
  }

  return (
    <BlockCreateContent
      activeAssignedBlockNames={props.activeAssignedBlockNames}
      blockOptions={props.blockOptions}
      onBackToBlockList={props.onBackToBlockList}
      onCreateBlock={props.onCreateBlock}
      onPatientInstructionsChange={props.onPatientInstructionsChange}
      onSelectBlock={props.onSelectBlock}
      patientInstructions={props.patientInstructions}
      selectedBlock={props.selectedBlock}
    />
  );
};
